// Store Imports
import { inject } from '@angular/core'
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals'
// Shared Imports

export interface EnvironmentState {
	version: string
}

const initialState: EnvironmentState = {
	version: '2.4.15',
}

export const EnvironmentStore = signalStore({ providedIn: 'root' }, withState(initialState))
